import _ from "lodash";
import {
  createAnecdotalMutation,
  createExemplarMutation,
  createMypObjectiveRubricMutation,
  editMypObjectiveRubricDescriptorMutation,
  createMypObjectiveRubricDescriptorsForObjectiveMutation,
  deleteMypObjectiveRubricDescriptorsForObjectiveMutation,
  createCommentAssessmentToolMutation,
  createScoreAssessmentToolMutation,
  createAssessmentGradeBoundaryMutation,
  updateScoreToolDataMutation,
  upsertDpAssessmentRubricV2Mutation,
  bulkEditMypObjectiveRubricDescriptorMutation,
  reorderAssessmentToolItemMutation,
  createAssessmentToolMutation,
  updateAnalysisToolDetailsMutation,
  deleteAssessmentToolMutation,
  bulkHandleAssessmentToolResponseMutation,
  updateAssessmentToolMutation,
  convertRubricToScoreBasedRubricMutation,
  updateAssessmentForStandardBasedRubricMutation,
  upsertGradeScaleToolMutation,
} from "./AssessmentToolMutations";
import client from "lib/apolloClient/client";
import {
  writeAssessmentToolOfParentInCache,
  getAssessmentToolOfParentFromCache,
  writeAssessmentToolElementInCache,
  getAssessmentToolElementFromCache,
  getCriteriaWithDescriptorFromCache,
  getOrganizationScoreRubricsFromCache,
  writeOrganizationStandardRubricsInCache,
  writeOrganizationScoreRubricsInCache,
  getOrganizationStandardRubricsFromCache,
} from "./AssessmentToolGraphqlHelpers";

import {
  getAssessmentToolNodeDetailsFromCacheV2,
  writeAssessmentToolNodeDetailsInCache,
} from "modules/CommonGraphqlHelpers";

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

import { generateRandomId } from "Utils";

import update from "immutability-helper";

import {
  writeAssessmentFragment,
  getAssessmentDetailsFromCache,
} from "Assessments/modules/AssessmentGraphqlHelpers";

import { removeAssessmentTool } from "Assessments/modules/AssessmentModule";
import {
  DP_ASSESSMENT_RUBRIC,
  GRADE_SCALE_TOOL,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
} from "Constants/stringConstants";
import {
  getSelectedAcademicYearId,
  getUserId,
  getCurrentCurriculumProgramType,
} from "modules/CommonSelectors";
import { getSelectedCurriculumId } from "../CommonSelectors";
import {
  getOrganizationScoreRubricsQuery,
  getOrganizationStandardRubricsQuery,
} from "./AssessmentToolQuery";

import { ASSESSMENT_TOOLS_OBJ } from "@toddle-edu/common-utils";
import { STANDARD_UIDS } from "modules/AssessmentTool/Constants";
import { getAssessmentToolNodeDetailsQuery } from "modules/CommonQuery";
import { STANDARD_RUBRIC_DISPLAY_SETTINGS } from "AppComponents/StandardRubric/modules/Constants";
import {
  getIsConfigurationEnabledForCPAY,
  getSettingValue,
} from "modules/PermissionModule";
import { USE_NEW_GRADING_SETUP_IN_COURSE_PERM } from "Constants/permissionConstants";
import { isWorksheetQueriesV2Enabled } from "Worksheet/modules/WorksheetFeatureFlags";

const REORDER_ITEM_TYPE_MAP = {
  RUBRIC_CRITERIA: "criterias",
  RUBRIC_INDICATOR: "indicators",
  CHECKLIST_ITEM: "checklistItems",
  CHECKLIST_OPTION: "checklistOptionItems",
  SINGLE_POINT_RUBRIC_STANDARD: "standards",
  STANDARD_RUBRIC_CRITERIA: "standardRubricCriterias",
  STANDARD_RUBRIC_DESCRIPTOR: "descriptors",
};

export const getUpdatedAssessmentToolDetails = ({
  parentId,
  parentType,
  mutationResponse,
  assessmentToolType,
  extraParams,
}) => {
  return (dispatch, getState) => {
    switch (parentType) {
      case "ASSESSMENT": {
        const insertAt = _.get(extraParams, "insertAt");
        const removeToolId = _.get(extraParams, "removeToolId");
        const assessmentId = _.get(extraParams, "assessmentId");

        const academicYearId = getSelectedAcademicYearId(getState());

        const assessmentToolDetails = getAssessmentToolOfParentFromCache({
          id: parentId,
          type: parentType,
          assessmentId: assessmentId,
          academicYearId,
        });

        const assessmentToolEdges = _.get(
          assessmentToolDetails,
          "assessmentTools.edges",
          []
        );

        const newToolEdge = {
          node: {
            id: generateRandomId(),
            assessmentToolItem: {
              ...mutationResponse,
            },
            assessmentToolType,
            isTeacherEvaluationEnable: true,
            isStudentEvaluationEnable: false,
            __typename: "AssessmentTool",
          },
          __typename: "AssessmentToolEdge",
        };

        let edges = [...assessmentToolEdges];

        if (removeToolId) {
          edges = _.filter(
            edges,
            ({ node }) => _.get(node, "assessmentToolItem.id") !== removeToolId
          );

          dispatch(
            removeAssessmentTool({
              parentId,
              parentType,
              id: removeToolId,
              type: assessmentToolType,
              writeToCache: false,
            })
          );
        }
        // For GRADE_SCALE_TOOL, remove any existing edge of the same type before adding new one
        // because the mutation upserts the tool, we don't want to have duplicates
        if (assessmentToolType === "GRADE_SCALE_TOOL") {
          edges = _.filter(
            edges,
            ({ node }) =>
              _.get(node, "assessmentToolType") !== "GRADE_SCALE_TOOL"
          );
        }

        // insert new tool at specific index
        if (!_.isNil(insertAt)) {
          edges.splice(insertAt, 0, newToolEdge);
        } else {
          edges.push(newToolEdge);
        }

        return {
          ...assessmentToolDetails,
          assessmentTools: {
            edges,
            __typename: "AssessmentToolConnection",
          },
        };
      }
      case "UNIT_PLAN":
        return {
          id: parentId,
          assessmentTool: {
            ...mutationResponse,
          },
          __typename: "UnitPlan",
        };
      case "QUESTION": {
        const assessmentId = _.get(extraParams, "assessmentId");
        const state = getState();
        const academicYearId = getSelectedAcademicYearId(state);

        const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();

        const assessmentToolDetails = getAssessmentToolOfParentFromCache({
          id: parentId,
          type: parentType,
          assessmentId: assessmentId,
          academicYearId,
        });

        const removeToolId = _.get(extraParams, "removeToolId");
        const insertAt = _.get(extraParams, "insertAt");

        const newToolEdge = {
          node: {
            id: generateRandomId(),
            assessmentToolItem: {
              ...mutationResponse,
            },
            assessmentToolType,
            isTeacherEvaluationEnable: true,
            isStudentEvaluationEnable: false,
            __typename: "AssessmentTool",
          },
          __typename: "AssessmentToolEdge",
        };

        if (!isWorksheetQueriesV2) {
          //WORKSHEET_RESTRUCTURING: Remove this block when queriesV2 is enabled
          const newOrganizationResources = _.map(
            _.get(
              assessmentToolDetails,
              "organizationResourcesV2.edges[0].node.childrenV2.edges"
            ),
            orgResource => {
              const newEdges = recursiveSearchAndUpdate({
                edges: _.get(orgResource, "node.childrenV2.edges"),
                parentId,
                newToolEdge,
                removeToolId,
                insertAt,
              });
              return update(orgResource, {
                node: {
                  childrenV2: { edges: { $set: newEdges } },
                },
              });
            }
          );

          if (!_.isEmpty(removeToolId)) {
            dispatch(
              removeAssessmentTool({
                parentId,
                parentType,
                id: removeToolId,
                type: assessmentToolType,
                writeToCache: false,
              })
            );
          }

          return update(assessmentToolDetails, {
            organizationResourcesV2: {
              edges: {
                [0]: {
                  node: {
                    childrenV2: {
                      edges: { $set: newOrganizationResources },
                    },
                  },
                },
              },
            },
          });
        } else {
          const questions = _.cloneDeep(
            _.get(assessmentToolDetails, "questions.edges", [])
          );
          const question = questions.find(question => question.id === parentId);

          // Get current assessment tools edges or initialize empty array
          const assessmentToolEdges = _.get(
            question,
            "assessmentTools.edges",
            []
          );

          let edges = [...assessmentToolEdges];

          if (removeToolId) {
            edges = _.filter(
              edges,
              ({ node }) =>
                _.get(node, "assessmentToolItem.id") !== removeToolId
            );

            dispatch(
              removeAssessmentTool({
                parentId,
                parentType,
                id: removeToolId,
                type: assessmentToolType,
                writeToCache: false,
              })
            );
          }

          // insert new tool at specific index
          if (!_.isNil(insertAt)) {
            edges.splice(insertAt, 0, newToolEdge);
          } else {
            edges.push(newToolEdge);
          }

          const updatedQuestion = {
            ...question,
            assessmentTools: {
              ..._.get(question, "assessmentTools", {}),
              edges,
              totalCount: _.size(edges),
            },
          };

          const updatedQuestions = _.map(questions, q => {
            if (_.get(q, "id") === parentId) {
              return updatedQuestion;
            }
            return q;
          });

          // Update the parent assessment tool details with the updated questions
          return update(assessmentToolDetails, {
            questions: {
              edges: { $set: updatedQuestions },
            },
          });
        }
      }

      default:
        return {};
    }
  };
};

const recursiveSearchAndUpdate = ({
  edges,
  parentId,
  newToolEdge,
  removeToolId,
  insertAt,
}) => {
  return _.map(edges, edge => {
    if (_.isEqual(_.get(edge, "node.item.id"), parentId)) {
      if (!_.isEmpty(removeToolId)) {
        let assessmentTools = _.get(
          edge,
          "node.item.assessmentTools.edges",
          []
        );

        assessmentTools = _.filter(
          assessmentTools,
          assessmentTool =>
            !_.isEqual(
              _.get(assessmentTool, "node.assessmentToolItem.id"),
              removeToolId
            )
        );

        // insert new tool at specific index
        if (!_.isEmpty(insertAt)) {
          assessmentTools.splice(insertAt, 0, newToolEdge);
        } else {
          assessmentTools.push(newToolEdge);
        }

        return update(edge, {
          node: {
            item: {
              assessmentTools: {
                edges: { $set: assessmentTools },
              },
            },
          },
        });
      }

      return update(edge, {
        node: {
          item: {
            assessmentTools: {
              edges: { $push: [newToolEdge] },
            },
          },
        },
      });
    }

    if (_.has(edge, "node.childrenV2.edges")) {
      return update(edge, {
        node: {
          childrenV2: {
            edges: {
              $set: recursiveSearchAndUpdate({
                edges: edge.node.childrenV2.edges,
                parentId: parentId,
                newToolEdge: newToolEdge,
                removeToolId,
                insertAt,
              }),
            },
          },
        },
      });
    }

    return edge;
  });
};

export const handledMYPRubricDescriptors = ({
  rubricId,
  newObjectives,
  oldObjectives,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const addedObjectives = _.difference(newObjectives, oldObjectives);
    const removedObjectives = _.difference(oldObjectives, newObjectives);
    if (!_.isEmpty(addedObjectives)) {
      await dispatch(
        addMYPRubricDescriptorsForObjective({
          rubricId,
          objectiveIds: addedObjectives,
          portalType,
        })
      );
    }

    if (!_.isEmpty(removedObjectives)) {
      await dispatch(
        deleteMYPRubricDescriptorsForObjective({
          rubricId,
          objectiveIds: removedObjectives,
          portalType,
        })
      );
    }
  };
};

export const addMYPRubricDescriptorsForObjective = ({
  rubricId,
  objectiveIds,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const newDescriptors = _.reduce(
      objectiveIds,
      (result, objectiveId) => {
        const criteria = getCriteriaWithDescriptorFromCache({
          id: objectiveId,
        });

        const descriptors = _.map(
          _.get(criteria, "objectiveRubricDescriptors", []),
          descriptor => {
            return { ...descriptor, id: generateRandomId() };
          }
        );
        result = _.concat(result, descriptors);
        return result;
      },
      []
    );

    let rubricData = getAssessmentToolNodeDetailsFromCacheV2({
      id: rubricId,
      type: "MYP_OBJECTIVE_RUBRIC",
    });
    let descriptors = _.get(rubricData, "descriptors", []);
    if (!descriptors) {
      descriptors = [];
    }

    descriptors = [...descriptors, ...newDescriptors];

    let data = {
      ...rubricData,

      descriptors,
    };

    writeAssessmentToolNodeDetailsInCache({
      id: rubricId,
      data,
      type: "MYP_OBJECTIVE_RUBRIC",
    });

    try {
      await client.mutate({
        mutation: createMypObjectiveRubricDescriptorsForObjectiveMutation,
        variables: {
          objectiveIds,
          rubricId,
          portalType,
        },
        update: (
          cache,
          {
            data: {
              planner: { createMypObjectiveRubricDescriptorsForObjective },
            },
          }
        ) => {
          rubricData = getAssessmentToolNodeDetailsFromCacheV2({
            id: rubricId,
            type: "MYP_OBJECTIVE_RUBRIC",
          });
          let descriptors = _.get(rubricData, "descriptors", []);
          if (!descriptors) {
            descriptors = [];
          }

          descriptors = _.filter(
            descriptors,
            des =>
              _.findIndex(
                createMypObjectiveRubricDescriptorsForObjective,
                createDes => {
                  return (
                    des.objective.id == createDes.objective.id &&
                    des.achievementLevel.id == createDes.achievementLevel.id
                  );
                }
              ) < 0
          );

          descriptors = [
            ...descriptors,
            ...createMypObjectiveRubricDescriptorsForObjective,
          ];

          data = {
            ...rubricData,

            descriptors,
          };

          writeAssessmentToolNodeDetailsInCache({
            id: rubricId,
            data,
            type: "MYP_OBJECTIVE_RUBRIC",
          });
        },
      });
    } catch (e) {
      setTimeout(() =>
        writeAssessmentToolNodeDetailsInCache({
          id: rubricId,
          data: rubricData,
          type: "MYP_OBJECTIVE_RUBRIC",
        })
      );
    }
  };
};

export const deleteMYPRubricDescriptorsForObjective = ({
  rubricId,
  objectiveIds,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const rubricData = getAssessmentToolNodeDetailsFromCacheV2({
      id: rubricId,
      type: "MYP_OBJECTIVE_RUBRIC",
    });

    try {
      await client.mutate({
        mutation: deleteMypObjectiveRubricDescriptorsForObjectiveMutation,
        variables: {
          objectiveIds,
          rubricId,
          portalType,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            deleteMypObjectiveRubricDescriptorsForObjective: {
              __typename: "DeleteOutput",
              isSuccess: true,
            },
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { deleteMypObjectiveRubricDescriptorsForObjective },
            },
          }
        ) => {
          if (deleteMypObjectiveRubricDescriptorsForObjective.isSuccess) {
            let descriptors = _.get(rubricData, "descriptors", []);
            if (!descriptors) {
              descriptors = [];
            }
            descriptors = _.filter(descriptors, descriptor => {
              return _.indexOf(objectiveIds, descriptor.objective.id) == -1;
            });
            const data = {
              ...rubricData,

              descriptors,
            };

            writeAssessmentToolNodeDetailsInCache({
              id: rubricId,
              data,
              type: "MYP_OBJECTIVE_RUBRIC",
            });
          }
        },
      });
    } catch (e) {
      setTimeout(() =>
        writeAssessmentToolNodeDetailsInCache({
          id: rubricId,
          data: rubricData,
          type: "MYP_OBJECTIVE_RUBRIC",
        })
      );
    }
  };
};

export const createMYPObjectiveRubricInAssessment = ({
  parentId,
  parentType,
  objectiveIds,
  toolType,
  removeToolId,
  insertAt,
  portalType,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const assessmentId = _.get(state, "assessment.assessmentData.assessmentId");
    const academicYearId = getSelectedAcademicYearId(state);
    const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();
    try {
      const result = await client.mutate({
        mutation: createMypObjectiveRubricMutation,
        variables: {
          parentId,
          parentType,
          objectiveIds,
          toolType,
          portalType,
        },

        update: (
          cache,
          {
            data: {
              planner: { createMypObjectiveRubric },
            },
          }
        ) => {
          if (!_.isEmpty(createMypObjectiveRubric)) {
            if (parentId) {
              const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache(
                {
                  id: parentId,
                  type: parentType,
                  assessmentId,
                  academicYearId,
                }
              );

              const newToolEdge = {
                node: {
                  id: generateRandomId(),
                  assessmentToolItem: {
                    ...createMypObjectiveRubric,
                  },
                  assessmentToolType: toolType,
                  isTeacherEvaluationEnable: true,
                  isStudentEvaluationEnable: false,
                  __typename: "AssessmentTool",
                },
                __typename: "AssessmentToolEdge",
              };

              let updatedAssessmentDetails;

              if (_.isEqual(parentType, "QUESTION")) {
                if (!isWorksheetQueriesV2) {
                  //WORKSHEET_RESTRUCTURING: Remove this block when queriesV2 is enabled
                  const newOrganizationResources = _.map(
                    _.get(
                      parentAssessmentToolDetails,
                      "organizationResourcesV2.edges[0].node.childrenV2.edges"
                    ),
                    orgResource => {
                      const newEdges = recursiveSearchAndUpdate({
                        edges: _.get(orgResource, "node.childrenV2.edges"),
                        parentId,
                        newToolEdge,
                      });

                      return update(orgResource, {
                        node: {
                          childrenV2: {
                            edges: { $set: newEdges },
                          },
                        },
                      });
                    }
                  );

                  updatedAssessmentDetails = update(
                    parentAssessmentToolDetails,
                    {
                      organizationResourcesV2: {
                        edges: {
                          [0]: {
                            node: {
                              childrenV2: {
                                edges: { $set: newOrganizationResources },
                              },
                            },
                          },
                        },
                      },
                    }
                  );
                } else {
                  const questions = _.cloneDeep(
                    _.get(parentAssessmentToolDetails, "questions.edges", [])
                  );
                  const question = questions.find(
                    question => question.id === parentId
                  );

                  // Get current assessment tools edges or initialize empty array
                  const assessmentToolEdges = _.get(
                    question,
                    "assessmentTools.edges",
                    []
                  );

                  // Add new tool edge to the assessment tools
                  const updatedEdges = [...assessmentToolEdges, newToolEdge];

                  const updatedQuestion = _.set(
                    question,
                    "assessmentTools.edges",
                    updatedEdges
                  );
                  const updatedQuestions = _.map(questions, q => {
                    if (_.get(q, "id") === parentId) {
                      return updatedQuestion;
                    }
                    return q;
                  });

                  // Update the parent assessment tool details with the updated questions
                  updatedAssessmentDetails = update(
                    parentAssessmentToolDetails,
                    {
                      questions: {
                        edges: { $set: updatedQuestions },
                      },
                    }
                  );
                }
              } else {
                const assessmentToolEdges = _.get(
                  parentAssessmentToolDetails,
                  "assessmentTools.edges",
                  []
                );

                let edges = [...assessmentToolEdges];

                if (removeToolId) {
                  edges = _.filter(
                    edges,
                    ({ node }) =>
                      _.get(node, "assessmentToolItem.id") !== removeToolId
                  );
                }

                // insert new tool at specific index
                if (!_.isNil(insertAt)) {
                  edges.splice(insertAt, 0, newToolEdge);
                } else {
                  edges.push(newToolEdge);
                }

                updatedAssessmentDetails = {
                  ...parentAssessmentToolDetails,
                  assessmentTools: {
                    edges,
                    __typename: "AssessmentToolConnection",
                  },
                };
              }

              if (!_.isEmpty(removeToolId)) {
                dispatch(
                  removeAssessmentTool({
                    parentId,
                    parentType,
                    id: removeToolId,
                    type: toolType,
                    writeToCache: false,
                  })
                );
              }

              setTimeout(() =>
                writeAssessmentToolOfParentInCache({
                  id: parentId,
                  data: updatedAssessmentDetails,
                  type: parentType,
                  academicYearId,
                })
              );
            }
          }
        },
      });

      return _.get(result, "data.planner.createMypObjectiveRubric.id");
    } catch (e) {
      console.error(e);
      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          parentId,
          data: getAssessmentToolOfParentFromCache({
            id: parentId,
            type: parentType,
            academicYearId,
          }),
          type: parentType,
          academicYearId,
        })
      );
    }
  };
};

export const createExemplarInAssessment = ({ parentId, parentType }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearId = getSelectedAcademicYearId(getState());

    try {
      const result = await client.mutate({
        mutation: createExemplarMutation,
        variables: {
          parentId,
          parentType,
          message: "",
          createdBy: userInfo.id,
        },

        update: (
          cache,
          {
            data: {
              planner: { createExemplar },
            },
          }
        ) => {
          if (!_.isEmpty(createExemplar)) {
            let updatedAssessmentDetails = {};
            let parentAssessmentToolDetails;
            if (parentId) {
              parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
                id: parentId,
                type: parentType,
                academicYearId,
              });

              const assessmentToolEdges = _.get(
                parentAssessmentToolDetails,
                "assessmentTools.edges",
                []
              );

              updatedAssessmentDetails = {
                ...parentAssessmentToolDetails,
                assessmentTools: {
                  edges: [
                    ...assessmentToolEdges,
                    {
                      node: {
                        id: generateRandomId(),
                        assessmentToolItem: {
                          ...createExemplar,
                        },
                        assessmentToolType: "EXEMPLAR",
                        isTeacherEvaluationEnable: true,
                        isStudentEvaluationEnable: false,
                        __typename: "AssessmentTool",
                      },
                      __typename: "AssessmentToolEdge",
                    },
                  ],
                  __typename: "AssessmentToolConnection",
                },
              };

              setTimeout(() =>
                writeAssessmentToolOfParentInCache({
                  id: parentId,
                  data: updatedAssessmentDetails,
                  type: parentType,
                  academicYearId,
                })
              );
            }
          }
        },
      });
    } catch (e) {
      console.error(e);
      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          parentId,
          data: getAssessmentToolOfParentFromCache({
            id: parentId,
            type: parentType,
            academicYearId,
          }),
          type: parentType,
          academicYearId,
        })
      );
    }
  };
};

export const createAnecdoteInAssessment = ({ parentId, parentType }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearId = getSelectedAcademicYearId(getState());

    try {
      const result = await client.mutate({
        mutation: createAnecdotalMutation,
        variables: {
          parentId,
          parentType,
          createdBy: userInfo.id,
        },

        update: (
          cache,
          {
            data: {
              planner: { createAnecdote },
            },
          }
        ) => {
          if (!_.isEmpty(createAnecdote)) {
            let updatedAssessmentDetails = {};
            let parentAssessmentToolDetails;
            if (parentId) {
              parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
                id: parentId,
                type: parentType,
                academicYearId,
              });

              const assessmentToolEdges = _.get(
                parentAssessmentToolDetails,
                "assessmentTools.edges",
                []
              );

              updatedAssessmentDetails = {
                ...parentAssessmentToolDetails,
                assessmentTools: {
                  edges: [
                    ...assessmentToolEdges,
                    {
                      node: {
                        id: generateRandomId(),
                        assessmentToolItem: {
                          ...createAnecdote,
                        },
                        assessmentToolType: "ANECDOTE",
                        isTeacherEvaluationEnable: true,
                        isStudentEvaluationEnable: false,
                        __typename: "AssessmentTool",
                      },
                      __typename: "AssessmentToolEdge",
                    },
                  ],
                  __typename: "AssessmentToolConnection",
                },
              };

              setTimeout(() =>
                writeAssessmentToolOfParentInCache({
                  id: parentId,
                  data: updatedAssessmentDetails,
                  type: parentType,
                  academicYearId,
                })
              );
            }
          }
        },
      });
    } catch (e) {
      console.error(e);
      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          parentId,
          data: getAssessmentToolOfParentFromCache({
            id: parentId,
            type: parentType,
            academicYearId,
          }),
          type: parentType,
          academicYearId,
        })
      );
    }
  };
};

/*
  Handle all types of Assessment Tool Elements local updates
  E.g - MYP_OBJECTIVE_DESCRIPTOR label update
*/

export const writeAssessmentToolElementLocal = ({ id, type, data }) => {
  return (dispatch, getState) => {
    const elementDetails = getAssessmentToolElementFromCache({ id, type });
    const updatedElementDetails = { ...elementDetails, ...data };
    writeAssessmentToolElementInCache({
      id,
      type,
      data: updatedElementDetails,
    });
  };
};

/*
  Handle all types of Assessment Tool Elements
  E.g - MYP_OBJECTIVE_DESCRIPTOR
*/
export const updateAssessmentToolElement = ({ id, data, type, portalType }) => {
  return async (dispatch, getState) => {
    try {
      let mutation = "";
      switch (type) {
        case "MYP_OBJECTIVE_DESCRIPTOR":
          mutation = editMypObjectiveRubricDescriptorMutation;
          break;
      }
      await client.mutate({
        mutation,
        variables: {
          id,
          ...data,
          portalType,
        },
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const upsertDpAssessmentRubricsV2InAssessment = params => {
  const { extraParams = {}, ...data } = params;

  return async (dispatch, getState) => {
    const state = getState();
    const assessmentId = _.get(state, "assessment.assessmentData.assessmentId");
    const academicYearId = getSelectedAcademicYearId(state);
    const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();
    try {
      const response = await client.mutate({
        mutation: upsertDpAssessmentRubricV2Mutation,
        variables: data,
      });

      const responseData = _.get(
        response,
        "data.planner.upsertDpAssessmentRubricsV2"
      );

      if (!_.isEmpty(responseData)) {
        const { parentId, parentType, toolType } = _.first(data?.input) || {};

        if (parentId) {
          const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache(
            {
              id: parentId,
              type: parentType,
              assessmentId: assessmentId,
              academicYearId,
            }
          );

          const newToolEdge = _.reduce(
            data?.input,
            (result, rubricData) => {
              const sourceRubricId = _.get(rubricData, "sourceRubricId");
              const newDpRubric = _.find(responseData?.response, rubric =>
                _.isEqual(sourceRubricId, _.get(rubric, "presetRubric.id"))
              );

              if (newDpRubric) {
                return {
                  node: {
                    id: _.get(responseData, ["response", "0", "id"]),
                    assessmentToolItem: newDpRubric,
                    assessmentToolType: toolType,
                    isTeacherEvaluationEnable: true,
                    isStudentEvaluationEnable: false,
                    __typename: "AssessmentTool",
                  },
                  __typename: "AssessmentToolEdge",
                };
              }
              return result;
            },
            {}
          );

          let updatedAssessmentDetails;

          if (parentType === "QUESTION") {
            if (!isWorksheetQueriesV2) {
              //WORKSHEET_RESTRUCTURING: Remove this block when queriesV2 is enabled
              const newOrganizationResources = _.map(
                _.get(
                  parentAssessmentToolDetails,
                  "organizationResourcesV2.edges[0].node.childrenV2.edges"
                ),
                orgResource => {
                  const newEdges = recursiveSearchAndUpdate({
                    edges: _.get(orgResource, "node.childrenV2.edges"),
                    parentId,
                    newToolEdge: newToolEdge,
                  });

                  return update(orgResource, {
                    node: {
                      childrenV2: {
                        edges: {
                          $set: _.isEmpty(newToolEdge)
                            ? _.get(orgResource, "node.childrenV2.edges")
                            : newEdges,
                        },
                      },
                    },
                  });
                }
              );

              updatedAssessmentDetails = update(parentAssessmentToolDetails, {
                organizationResourcesV2: {
                  edges: {
                    [0]: {
                      node: {
                        childrenV2: {
                          edges: { $set: newOrganizationResources },
                        },
                      },
                    },
                  },
                },
              });
            } else {
              const questions = _.cloneDeep(
                _.get(parentAssessmentToolDetails, "questions.edges", [])
              );
              const question = questions.find(
                question => question.id === parentId
              );

              // Get current assessment tools edges or initialize empty array
              const assessmentToolEdges = _.get(
                question,
                "assessmentTools.edges",
                []
              );

              // Add new tool edge to the assessment tools
              const updatedEdges = [...assessmentToolEdges, newToolEdge];

              const updatedQuestion = _.set(
                question,
                "assessmentTools.edges",
                updatedEdges
              );
              const updatedQuestions = _.map(questions, q => {
                if (_.get(q, "id") === parentId) {
                  return updatedQuestion;
                }
                return q;
              });

              // Update the parent assessment tool details with the updated questions
              updatedAssessmentDetails = update(parentAssessmentToolDetails, {
                questions: {
                  edges: { $set: updatedQuestions },
                },
              });
            }
          } else {
            const insertAt = _.get(extraParams, "insertAt");
            const removeToolId = _.get(extraParams, "removeToolId");

            const assessmentToolEdges = _.get(
              parentAssessmentToolDetails,
              "assessmentTools.edges",
              []
            );

            let edges = [...assessmentToolEdges];

            if (removeToolId) {
              edges = _.filter(
                edges,
                ({ node }) =>
                  _.get(node, "assessmentToolItem.id") !== removeToolId
              );

              dispatch(
                removeAssessmentTool({
                  parentId,
                  parentType,
                  id: removeToolId,
                  type: DP_ASSESSMENT_RUBRIC,
                  writeToCache: false,
                })
              );
            }

            // insert new tool at specific index
            if (!_.isNil(insertAt)) {
              edges.splice(insertAt, 0, newToolEdge);
            } else {
              edges.push(newToolEdge);
            }

            updatedAssessmentDetails = _.assign(
              {},
              parentAssessmentToolDetails,
              {
                assessmentTools: {
                  edges: _.filter(edges, edge => !_.isEmpty(edge)),
                  __typename: "AssessmentToolConnection",
                },
              }
            );
          }

          setTimeout(() =>
            writeAssessmentToolOfParentInCache({
              id: parentId,
              data: updatedAssessmentDetails,
              type: parentType,
              academicYearId,
            })
          );
        }
      }
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const createCommentAssessmentTool = params => {
  const { parentId, parentType } = params;

  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());

    const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
      id: parentId,
      type: parentType,
      academicYearId,
    });

    try {
      return await client.mutate({
        mutation: createCommentAssessmentToolMutation,
        variables: params,
        update: (
          cache,
          {
            data: {
              planner: { createCommentAssessmentTool },
            },
          }
        ) => {
          const assessmentToolEdges = _.get(
            parentAssessmentToolDetails,
            "assessmentTools.edges",
            []
          );

          const updatedAssessmentDetails = {
            ...parentAssessmentToolDetails,
            assessmentTools: {
              edges: [
                ...assessmentToolEdges,
                {
                  node: {
                    id: generateRandomId(),
                    assessmentToolItem: {
                      id: _.get(createCommentAssessmentTool, "response.id", ""),
                      __typename: "CommentAssessmentTool",
                    },
                    assessmentToolType: "COMMENT",
                    isTeacherEvaluationEnable: true,
                    isStudentEvaluationEnable: false,
                    __typename: "AssessmentTool",
                  },
                  __typename: "AssessmentToolEdge",
                },
              ],
              __typename: "AssessmentToolConnection",
            },
          };

          setTimeout(() => {
            writeAssessmentToolOfParentInCache({
              id: parentId,
              data: updatedAssessmentDetails,
              type: parentType,
              academicYearId,
            });
          });
        },
      });
    } catch (e) {
      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          id: parentId,
          data: parentAssessmentToolDetails,
          type: parentType,
          academicYearId,
        })
      );
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const createScoreAssessmentTool = params => {
  const { parentId, parentType } = params;

  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    try {
      return await client.mutate({
        mutation: createScoreAssessmentToolMutation,
        variables: params,
        update: (
          cache,
          {
            data: {
              planner: { createScoreAssessmentTool },
            },
          }
        ) => {
          if (!_.isEmpty(createScoreAssessmentTool)) {
            const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache(
              {
                id: parentId,
                type: parentType,
                academicYearId,
              }
            );

            const assessmentToolEdges = _.get(
              parentAssessmentToolDetails,
              "assessmentTools.edges",
              []
            );

            const updatedAssessmentDetails = {
              ...parentAssessmentToolDetails,
              assessmentTools: {
                edges: [
                  ...assessmentToolEdges,
                  {
                    node: {
                      id: generateRandomId(),
                      assessmentToolItem: {
                        id: _.get(createScoreAssessmentTool, "response.id", ""),
                        __typename: "ScoreAssessmentTool",
                      },
                      assessmentToolType: "SCORE",
                      isTeacherEvaluationEnable: true,
                      isStudentEvaluationEnable: false,
                      __typename: "AssessmentTool",
                    },
                    __typename: "AssessmentToolEdge",
                  },
                ],
                __typename: "AssessmentToolConnection",
              },
            };

            setTimeout(() =>
              writeAssessmentToolOfParentInCache({
                id: parentId,
                data: updatedAssessmentDetails,
                type: parentType,
                academicYearId,
              })
            );
          }
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateScoreToolData = params => {
  const { parentId, parentType, assessmentId } = params;

  const input = _.omit(params, ["parentId", "parentType", "assessmentId"]);

  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());

    try {
      await client.mutate({
        mutation: updateScoreToolDataMutation,
        variables: {
          input,
        },
      });
    } catch (e) {
      const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
        id: parentId,
        type: parentType,
        academicYearId,
      });
      const collaboratorsFilter = {
        userAcademicYearId: academicYearId,
      };
      const assessmentDetails = getAssessmentDetailsFromCache({
        id: assessmentId,
        collaboratorsFilter,
      });

      setTimeout(() => {
        writeAssessmentToolOfParentInCache({
          id: parentId,
          data: parentAssessmentToolDetails,
          type: parentType,
          academicYearId,
        });
      });

      setTimeout(() => {
        writeAssessmentFragment({
          assessmentId: assessmentId ? assessmentId : parentId,
          data: assessmentDetails,
          variables: {
            collaboratorsFilter,
          },
        });
      });

      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

const getUpdatedScoreToolData = ({
  assessmentToolEdges,
  maxScore,
  createNewIfNotExists = false,
}) => {
  let updatedAssessmentToolEdges = assessmentToolEdges;

  if (createNewIfNotExists) {
    const doesScoreToolExist = !_.isEmpty(
      _.find(
        assessmentToolEdges,
        ({ node }) => _.get(node, "assessmentToolType") === "SCORE"
      )
    );

    if (doesScoreToolExist && _.isEmpty(maxScore)) {
      updatedAssessmentToolEdges = _.filter(
        assessmentToolEdges,
        ({ node }) => _.get(node, "assessmentToolType") !== "SCORE"
      );
    } else if (!doesScoreToolExist && !_.isEmpty(maxScore)) {
      const newScoreToolEdge = {
        node: {
          id: generateRandomId(),
          assessmentToolItem: {
            id: generateRandomId(),
            scoreToolData: {
              id: generateRandomId(),
              maxScore,
              __typename: "ScoreToolData",
            },
            __typename: "ScoreAssessmentTool",
          },
          assessmentToolType: "SCORE",
          isTeacherEvaluationEnable: true,
          isStudentEvaluationEnable: false,
          __typename: "AssessmentTool",
        },
        __typename: "AssessmentToolEdge",
      };

      updatedAssessmentToolEdges = [...assessmentToolEdges, newScoreToolEdge];
    }
  }

  return _.map(updatedAssessmentToolEdges, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType");

    if (assessmentToolType === "SCORE") {
      return {
        node: update(node, {
          assessmentToolItem: {
            scoreToolData: {
              maxScore: {
                $set: maxScore,
              },
            },
          },
        }),
        __typename: "AssessmentToolEdge",
      };
    } else {
      return { node, __typename: "AssessmentToolEdge" };
    }
  });
};

export const writeScoreToolDataInCache = params => {
  return async (dispatch, getState) => {
    const { parentId, parentType, maxScore } = params;
    const academicYearId = getSelectedAcademicYearId(getState());

    const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
      id: parentId,
      type: parentType,
      academicYearId,
    });

    const assessmentToolEdges = _.get(
      parentAssessmentToolDetails,
      "assessmentTools.edges",
      []
    );

    const updatedAssessmentTools = getUpdatedScoreToolData({
      assessmentToolEdges,
      maxScore,
    });

    const updatedParentAssessmentToolDetails = {
      ...parentAssessmentToolDetails,
      assessmentTools: {
        edges: updatedAssessmentTools,
        __typename: "AssessmentToolConnection",
      },
    };

    writeAssessmentToolOfParentInCache({
      id: parentId,
      data: updatedParentAssessmentToolDetails,
      type: parentType,
      academicYearId,
    });
  };
};

export const writeAssessmentScoreToolDataInCache = params => {
  return async (dispatch, getState) => {
    const {
      parentId,
      maxScore,
      assessmentId,
      createNewIfNotExists = false,
    } = params;

    const academicYearId = getSelectedAcademicYearId(getState());
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const assessmentDetails = getAssessmentDetailsFromCache({
      id: assessmentId,
      collaboratorsFilter,
    });

    const assessmentToolEdges = _.get(
      assessmentDetails,
      "assessmentTools.edges",
      []
    );

    const updatedAssessmentTools = getUpdatedScoreToolData({
      assessmentToolEdges,
      maxScore,
      createNewIfNotExists,
    });

    const updatedAssessmentDetails = {
      ...assessmentDetails,
      assessmentTools: {
        edges: updatedAssessmentTools,
        __typename: "AssessmentToolConnection",
      },
    };

    writeAssessmentFragment({
      assessmentId: assessmentId ? assessmentId : parentId,
      data: updatedAssessmentDetails,
      variables: {
        collaboratorsFilter,
      },
    });
  };
};

export const createAssessmentGradeBoundaryTool = params => {
  const { parentId, parentType, type, portalType } = params;

  const INPUT_VARIABLES = [
    "parentId",
    "parentType",
    "type",
    "label",
    "isShowGradeBoundaries",
    "associatedEntites",
    "categories",
    "criteriaSetId",
  ];

  return async (dispatch, getState) => {
    const state = getState();
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const assessmentId = _.get(state, "assessment.assessmentData.assessmentId");
    const academicYearId = getSelectedAcademicYearId(state);

    const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();
    try {
      return await client.mutate({
        mutation: createAssessmentGradeBoundaryMutation,
        variables: {
          input: {
            ..._.pick(params, INPUT_VARIABLES),
            curriculumProgramId,
          },
          portalType,
        },
        update: (
          cache,
          {
            data: {
              planner: { createAssessmentGradeBoundaryTool },
            },
          }
        ) => {
          if (!_.isEmpty(createAssessmentGradeBoundaryTool)) {
            const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache(
              {
                id: parentId,
                type: parentType,
                assessmentId: assessmentId,
                academicYearId,
              }
            );

            const newToolEdge = {
              node: {
                id: _.get(
                  createAssessmentGradeBoundaryTool,
                  "response.id",
                  generateRandomId()
                ),
                assessmentToolItem: _.get(
                  createAssessmentGradeBoundaryTool,
                  "response",
                  {}
                ),
                assessmentToolType: type,
                isTeacherEvaluationEnable: true,
                isStudentEvaluationEnable: false,
                __typename: "AssessmentTool",
              },
              __typename: "AssessmentToolEdge",
            };

            let updatedAssessmentDetails;
            if (parentType == "QUESTION") {
              if (!isWorksheetQueriesV2) {
                //WORKSHEET_RESTRUCTURING: Remove this block when queriesV2 is enabled
                // Old nested structure
                const newOrganizationResources = _.map(
                  _.get(
                    parentAssessmentToolDetails,
                    "organizationResourcesV2.edges[0].node.childrenV2.edges"
                  ),
                  orgResource => {
                    const newEdges = recursiveSearchAndUpdate({
                      edges: _.get(orgResource, "node.childrenV2.edges"),
                      parentId,
                      newToolEdge,
                    });

                    return update(orgResource, {
                      node: {
                        childrenV2: { edges: { $set: newEdges } },
                      },
                    });
                  }
                );

                updatedAssessmentDetails = update(parentAssessmentToolDetails, {
                  organizationResourcesV2: {
                    edges: {
                      [0]: {
                        node: {
                          childrenV2: {
                            edges: { $set: newOrganizationResources },
                          },
                        },
                      },
                    },
                  },
                });
              } else {
                // New flat structure
                const questions = _.get(
                  parentAssessmentToolDetails,
                  "questions.edges",
                  []
                );
                const question = _.find(questions, { id: parentId });

                const assessmentTools = _.get(
                  question,
                  "assessmentTools.edges",
                  []
                );

                const newEdges = update(assessmentTools, {
                  $push: [newToolEdge],
                });

                const updatedQuestion = {
                  ...question,
                  assessmentTools: {
                    ..._.get(question, "assessmentTools"),
                    edges: newEdges,
                    totalCount: _.size(newEdges),
                  },
                };

                updatedAssessmentDetails = {
                  ...parentAssessmentToolDetails,
                  questions: {
                    ..._.get(parentAssessmentToolDetails, "questions", {}),
                    edges: _.map(questions, q => {
                      if (_.isEqual(q.id, question.id)) {
                        return updatedQuestion;
                      }
                      return q;
                    }),
                  },
                };
              }
            } else {
              const assessmentToolEdges = _.get(
                parentAssessmentToolDetails,
                "assessmentTools.edges",
                []
              );

              const newEdges = update(assessmentToolEdges, {
                $push: [newToolEdge],
              });

              updatedAssessmentDetails = update(parentAssessmentToolDetails, {
                assessmentTools: { edges: { $set: newEdges } },
              });
            }

            setTimeout(() =>
              writeAssessmentToolOfParentInCache({
                id: parentId,
                data: updatedAssessmentDetails,
                type: parentType,
                academicYearId,
              })
            );
          }
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const bulkEditMypObjectiveRubricDescriptor = descriptors => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: bulkEditMypObjectiveRubricDescriptorMutation,
        variables: {
          descriptors,
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

const _getUpdatedToolDataForReorder = params => {
  const { originalToolData, itemType, itemsWithSequence } = params;

  switch (itemType) {
    case "STANDARD_RUBRIC_DESCRIPTOR": {
      // Get all item IDs from the updated sequence
      const itemIds = _.map(itemsWithSequence, "id");

      return {
        ...originalToolData,
        standardRubricCriterias: _.map(
          originalToolData.standardRubricCriterias,
          criterion => {
            // Extract descriptor IDs from this criterion
            const criterionIds = _.map(criterion.descriptors, "id");

            // Check if the arrays contain exactly the same elements
            // _.isEmpty(_.xor(a, b)) returns true if arrays contain the same elements
            const hasSameElements =
              _.size(criterionIds) === _.size(itemIds) &&
              _.isEmpty(_.xor(criterionIds, itemIds));

            return {
              ...criterion,
              descriptors: hasSameElements
                ? itemsWithSequence
                : criterion.descriptors,
            };
          }
        ),
      };
    }

    default:
      // All other item types use the mapping directly
      return {
        ...originalToolData,
        [REORDER_ITEM_TYPE_MAP[itemType]]: itemsWithSequence,
      };
  }
};

export const reorderAssessmentToolItem = params => {
  const {
    itemId,
    itemType,
    toolId,
    toolType,
    putAfterItemId,
    updatedValue,
  } = params;

  const input = { itemId, itemType, toolId, putAfterItemId };

  const originalToolData = getAssessmentToolNodeDetailsFromCacheV2({
    id: toolId,
    type: toolType,
  });

  const itemsWithSequence = _.map(updatedValue, (value, index) => ({
    ...value,
    displaySequence: index + 1,
  }));

  const updatedToolData = _getUpdatedToolDataForReorder({
    originalToolData,
    itemType,
    itemsWithSequence,
  });

  writeAssessmentToolNodeDetailsInCache({
    id: toolId,
    type: toolType,
    data: updatedToolData,
  });

  return async dispatch => {
    try {
      await client.mutate({
        mutation: reorderAssessmentToolItemMutation,
        variables: { input },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      writeAssessmentToolNodeDetailsInCache({
        id: toolId,
        type: toolType,
        data: originalToolData,
      });
    }
  };
};

export const createAssessmentTool = params => {
  const {
    parentId,
    parentType,
    assessmentToolType,
    portalType,
    label,
    copyAssessmentToolId,
    isGlobal,
    shouldRefetchQuery = false,
    filters,
    extraParams,
  } = params;

  return async (dispatch, getState) => {
    const state = getState();

    const curriculumProgramId = getSelectedCurriculumId(state);
    const academicYearId = getSelectedAcademicYearId(state);

    const { gradeScaleId } = extraParams || {};

    const input = {
      parentId,
      parentType,
      assessmentToolType,
      label,
      copyAssessmentToolId,
      isGlobal,
      curriculumProgramId,
      gradeScaleId,
    };

    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;

    const refetchQueries = [];

    const rubricConfigs = {
      [SCORE_BASED_RUBRIC]: {
        query: getOrganizationScoreRubricsQuery,
      },
      [STANDARD_BASED_RUBRIC]: {
        query: getOrganizationStandardRubricsQuery,
      },
    };

    const currentConfig = rubricConfigs[assessmentToolType];

    if (currentConfig) {
      if (shouldRefetchQuery) {
        refetchQueries.push({
          query: currentConfig.query,
          variables: {
            id: organizationId,
            filters,
          },
        });
      }

      // if user is creating a new rubric then copy user preference to the new rubric
      // if user is using a template then backend will copy the source rubric metadata to copied rubric
      if (!copyAssessmentToolId) {
        const settingName =
          STANDARD_RUBRIC_DISPLAY_SETTINGS[assessmentToolType];
        const selectedDisplayOptions = getSettingValue({
          name: settingName,
          userId: getUserId(),
          readFromUserAndOrgLevel: true,
        });

        if (!_.isEmpty(selectedDisplayOptions)) {
          input.metadata = { selectedDisplayOptions };
        }
      }
    }

    try {
      const response = await client.mutate({
        mutation: createAssessmentToolMutation,
        variables: { input, portalType },
        awaitRefetchQueries: shouldRefetchQuery,
        refetchQueries,
        update: (
          cache,
          {
            data: {
              planner: { createAssessmentTool },
            },
          }
        ) => {
          const assessmentToolItem = _.get(
            createAssessmentTool,
            "response.assessmentToolItem",
            {}
          );

          if (
            _.includes(
              [STANDARD_BASED_RUBRIC, SCORE_BASED_RUBRIC],
              assessmentToolType
            )
          ) {
            if (!_.isEmpty(assessmentToolItem)) {
              if (parentId) {
                const assessmentToolDetails = dispatch(
                  getUpdatedAssessmentToolDetails({
                    parentId,
                    parentType,
                    mutationResponse: assessmentToolItem,
                    assessmentToolType,
                    extraParams,
                  })
                );

                setTimeout(() =>
                  writeAssessmentToolOfParentInCache({
                    id: parentId,
                    data: assessmentToolDetails,
                    type: parentType,
                    academicYearId,
                  })
                );
              }
            }
          }
        },
      });

      if (isGlobal) {
        let toolLabel = "";

        switch (assessmentToolType) {
          case SCORE_BASED_RUBRIC:
            toolLabel = "score_based_rubric";
            break;
          case STANDARD_BASED_RUBRIC:
            toolLabel = "standard_based_rubric";
            break;
        }

        if (toolLabel) {
          if (input.label) {
            dispatch(
              setToastMsg({
                msg: "toastMsgs:successfully_saved_as_template_with_label",
                locale_params: [
                  {
                    key: "tool",
                    value: `common:${toolLabel}`,
                    isPlainText: false,
                  },
                  {
                    key: "templateName",
                    value: input.label,
                    isPlainText: false,
                  },
                ],
                type: "success",
              })
            );
          } else {
            dispatch(
              setToastMsg({
                msg: "toastMsgs:label_successfully_duplicated",
                locale_params: [
                  {
                    key: "label",
                    value: `common:${toolLabel}`,
                    isPlainText: false,
                  },
                ],
                type: "success",
              })
            );
          }
        }
      }

      const toolId = _.get(
        response,
        "data.planner.createAssessmentTool.response.id"
      );

      return _.first(_.split(toolId, "_"));
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateAnalysisToolDetails = variables => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateAnalysisToolDetailsMutation,
        variables,
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteAssessmentTool = params => {
  const { id, assessmentToolType, filters, showDiscardToast = false } = params;

  return async dispatch => {
    const currentTool = ASSESSMENT_TOOLS_OBJ[assessmentToolType];

    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;

    const input = {
      id,
      assessmentToolType,
    };

    let organizationDetails = [],
      tools = [];

    switch (assessmentToolType) {
      case SCORE_BASED_RUBRIC: {
        organizationDetails = getOrganizationScoreRubricsFromCache({
          id: organizationId,
          filters,
        });

        tools = _.get(organizationDetails, ["node", currentTool?.itemName], []);

        break;
      }
      case STANDARD_BASED_RUBRIC: {
        organizationDetails = getOrganizationStandardRubricsFromCache({
          id: organizationId,
          filters,
        });

        tools = _.get(organizationDetails, ["node", currentTool?.itemName], []);

        break;
      }
    }

    try {
      await client.mutate({
        mutation: deleteAssessmentToolMutation,
        variables: { input },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            deleteAssessmentTool: true,
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { deleteAssessmentTool },
            },
          }
        ) => {
          if (deleteAssessmentTool) {
            const updatedTools = _.filter(tools, tool => tool.id != id);
            const data = {
              ...organizationDetails,
              id: _.get(organizationDetails, "node.id"),
              [currentTool?.itemName]: updatedTools,
              __typename: "Organization",
            };

            switch (assessmentToolType) {
              case SCORE_BASED_RUBRIC: {
                writeOrganizationScoreRubricsInCache({
                  id: organizationId,
                  data,
                  filters,
                });
                break;
              }
              case STANDARD_BASED_RUBRIC: {
                writeOrganizationStandardRubricsInCache({
                  id: organizationId,
                  data,
                  filters,
                });
                break;
              }
            }
          }
        },
      });

      dispatch(
        setToastMsg({
          msg: showDiscardToast
            ? "toastMsgs:label_successfully_discarded"
            : "toastMsgs:label_successfully_deleted",
          type: "success",
          locale_params: [
            { key: "label", value: currentTool?.locale, isPlainText: false },
          ],
        })
      );
    } catch (e) {
      switch (assessmentToolType) {
        case SCORE_BASED_RUBRIC: {
          writeOrganizationScoreRubricsInCache({
            id: organizationId,
            data: organizationDetails,
            filters,
          });
          break;
        }
        case STANDARD_BASED_RUBRIC: {
          writeOrganizationStandardRubricsInCache({
            id: organizationId,
            data: organizationDetails,
            filters,
          });
          break;
        }
      }

      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const bulkHandleAssessmentToolResponse = ({ input }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: bulkHandleAssessmentToolResponseMutation,
        variables: { input },
      });
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAssessmentTool = ({ input }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateAssessmentToolMutation,
        variables: { input },
      });
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const getAssessmentToolNodeDetails = variables => {
  return async dispatch => {
    try {
      const response = await client.query({
        query: getAssessmentToolNodeDetailsQuery,
        variables,
        fetchPolicy: "network-only",
      });

      return _.get(response, "data.node", {});
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};

export const convertRubricToScoreBasedRubric = ({ input }) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: convertRubricToScoreBasedRubricMutation,
        variables: { input },
      });

      const mutationData = _.get(
        response,
        "data.planner.convertRubricToScoreBasedRubric"
      );

      const warning = _.get(mutationData, "warning");

      if (warning) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return;
      }

      return _.get(mutationData, "response.assessmentToolItem");
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAssessmentForStandardBasedRubric = ({ input, uids }) => {
  return async dispatch => {
    try {
      const userInfo = getUserInfo();

      if (userInfo?.id) {
        input.updatedBy = userInfo.id;
      }

      return await client.mutate({
        mutation: updateAssessmentForStandardBasedRubricMutation,
        variables: { input, uids },
      });
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const syncStandardsWithStandardBasedRubric = params => {
  const {
    assessmentId,
    selectedStandards = [],
    initialSelectedStandards = [],
    isTemplate = false,
  } = params;

  return async (dispatch, getState) => {
    const state = getState();

    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramType = getCurrentCurriculumProgramType(state);

    const assessmentDetails = getAssessmentDetailsFromCache({
      id: assessmentId,
      collaboratorsFilter: {
        userAcademicYearId: academicYearId,
      },
    });

    const { allFields: assessmentFields } = assessmentDetails || {};

    const standardUID = STANDARD_UIDS[curriculumProgramType];
    const standardField = _.find(assessmentFields, { uid: standardUID });

    // tag standards in the learning goals section
    if (
      !_.isEmpty(standardField) &&
      assessmentId &&
      getIsConfigurationEnabledForCPAY({
        configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        academicYearId: academicYearId,
      })
    ) {
      const { id, uid, value } = standardField || {};

      const valueToSet = [...(value || [])];

      let addedStandards = _.difference(
        selectedStandards,
        initialSelectedStandards
      );

      let removedStandards = _.difference(
        initialSelectedStandards,
        selectedStandards
      );

      if (isTemplate) {
        addedStandards = _.filter(
          selectedStandards,
          standard => !_.includes(initialSelectedStandards, standard)
        );

        // when adding standard rubric from template, there will never be a case where standards are removed
        removedStandards = [];
      }

      if (!_.isEmpty(addedStandards) || !_.isEmpty(removedStandards)) {
        if (!_.isEmpty(addedStandards)) {
          valueToSet.push(...addedStandards);
        }

        if (!_.isEmpty(removedStandards)) {
          _.remove(valueToSet, id => _.includes(removedStandards, id));
        }

        // call updateAssessment and refetch standards to update the standards in the learning goals section
        await dispatch(
          updateAssessmentForStandardBasedRubric({
            input: {
              assessmentId,
              fields: [
                {
                  id,
                  value: valueToSet,
                  valuesToAdd: addedStandards,
                  valuesToRemove: removedStandards,
                  hasAddRemoveValues: true,
                },
              ],
            },
            uids: [uid],
          })
        );
      }
    }
  };
};

export const upsertGradeScaleTool = params => {
  return async (dispatch, getState) => {
    const { parentId, parentType, extraParams } = params;
    const { gradeScaleEntityMapId } = extraParams || {};

    const academicYearId = getSelectedAcademicYearId(getState());

    const input = {
      parentId,
      parentType,
      gradeScaleEntityMapId,
    };

    const originalAssessmentToolDetails = getAssessmentToolOfParentFromCache({
      id: parentId,
      type: parentType,
      academicYearId,
    });

    try {
      const result = await client.mutate({
        mutation: upsertGradeScaleToolMutation,
        variables: { input },
        update: (
          cache,
          {
            data: {
              planner: { upsertGradeScaleTool },
            },
          }
        ) => {
          if (!_.isEmpty(upsertGradeScaleTool)) {
            const response = _.get(upsertGradeScaleTool, "response");

            const { id, assessmentToolItem } = response || {};

            if (parentId && response) {
              const assessmentToolEdges = _.get(
                originalAssessmentToolDetails,
                "assessmentTools.edges",
                []
              );

              const newToolEdge = {
                node: {
                  id,
                  assessmentToolItem,
                  assessmentToolType: GRADE_SCALE_TOOL,
                  isTeacherEvaluationEnable: true,
                  isStudentEvaluationEnable: false,
                  __typename: "AssessmentTool",
                },
                __typename: "AssessmentToolEdge",
              };

              // Remove any existing grade scale tool before adding the new one
              // because this is an upsert operation
              const edges = _.filter(
                assessmentToolEdges,
                ({ node }) =>
                  _.get(node, "assessmentToolType") !== GRADE_SCALE_TOOL
              );

              // Add the new grade scale tool
              edges.push(newToolEdge);

              const updatedAssessmentDetails = {
                ...originalAssessmentToolDetails,
                assessmentTools: {
                  edges,
                  __typename: "AssessmentToolConnection",
                },
              };

              writeAssessmentToolOfParentInCache({
                id: parentId,
                data: updatedAssessmentDetails,
                type: parentType,
                academicYearId,
              });
            }
          }
        },
      });

      return _.get(result, "data.planner.upsertGradeScaleTool.response.id");
    } catch (e) {
      writeAssessmentToolOfParentInCache({
        id: parentId,
        data: originalAssessmentToolDetails,
        type: parentType,
        academicYearId,
      });

      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};
